export default __webpack_public_path__ + "static/media/cert-fsi-consumer.ab471a08.jpg";